import React, { useContext, useEffect, useRef, useState } from "react";
import bg from "../../../assets/images/background.png";
import Button from "../../../components/Button/Button";
import Navbar from "../../../components/Navbar/Navbar";
import "./license.scss";
import AnimatedModal from "../../../components/Modal/AnimatedModal";
import { closeIcon, searchIcon } from "../../../helper/icons";
import { axiosApiInstance } from "../../../helper/request";
import Loading from "../../../components/Loading/Loading";
import InputBox from "../../../components/Inputbox/InputBox";
import Scroller from "../../../components/Scroller/ScrollBar";
import LicenseList from "./LicenseList";
import { handleFocus } from "../../../components/DeveloperModal/ManufacturerModal ";
import { LoadingText } from "../../auth/register/AuthRegister";
import { useDebouncedEffect } from "../../../helper/useDebounce";
import Searchbar from "../../../components/Searchbar/Searchbar";
import { encryptStorage } from "../../../helper/storage";
import { ThemeContext } from "../../../helper/context";
import Pagination from "../../../components/Pagination/Pagination";
let msg = {
  type: "alert",
  header: "Error",
  errorText: "Something Went Wrong",
};
let Role = [];
let currentIndex = 0;
let attributeName = [];
let mgfUserName = [];
let usersUserName = [];
let removeMfgData = [];
let currentAtrLength = 0;
let changePage = 1;
let changeUserPage = 1;
let flag = false;
let userFlag = false;

export default function License() {
  const userScroll = useRef();
  const scrollbar = useRef(null);
  const createLicenseScroll = useRef();
  const arr = ["attribute_name", "monthly", "quarterly", "yearly", "lifetime"];
  const arr2 = [
    "attribute_name",
    "monthly",
    "quarterly",
    "yearly",
    "lifetime",
    "",
  ];
  const [License, setLicense] = useState([]);
  const themeContext = useContext(ThemeContext);
  const [LicenseSearchText, setLicenseSearchText] = useState("");
  const [UniqueCheck, setUniqueCheck] = useState(false);
  const [isActive, setIsActive] = useState("");
  const [Licenselist, setLicenselist] = useState([]);
  const [LicenseModal, setLicenseModal] = useState(false);
  const [ShowAlert, setShowAlert] = useState(false);
  const [LicenseName, setLicenseName] = useState("");
  const [Type, setType] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [TotalPages, setTotalPages] = useState(0);
  const [TotalRestrictedUsers, setTotalRestrictedUsers] = useState(0);
  const [UpdatedMarkup, setUpdatedMarkup] = useState([]);
  const [AttributeNames, setAttributeNames] = useState([]);
  const [MarkupModal, setMarkupModal] = useState(false);
  const [currentAmount, setcurrentAmount] = useState(0);
  const [mfrDetails, setmfrDetails] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [UserList, setUserList] = useState([]);
  const [EditLicenseModal, setEditLicenseModal] = useState(false);
  const [EditLicense, setEditLicense] = useState([]);
  const [assignModal, setassignModal] = useState(false);
  const [OperatorLoading, setOperatorLoading] = useState(false);
  const [DisappearSearch, setDisappearSearch] = useState(false);

  useDebouncedEffect(
    () => (SearchText ? getUsers() : undefined),
    [SearchText],
    1000
  );

  useDebouncedEffect(
    () => {
      changePage = 1;
      fetchLicense(1);
    },
    [LicenseSearchText],
    1000
  );

  useDebouncedEffect(
    () => (LicenseName ? getUnique() : undefined),
    [LicenseName],
    1000
  );

  useEffect(() => {
    License.length > currentAtrLength &&
      createLicenseScroll.current.scrollToBottom();
  }, [License]);

  const fetchLicense = (page) => {
    setIsLoading(true);
    let url =
      "license/search/license?license_type=device&licensename=" +
      LicenseSearchText +
      "&page=" +
      page +
      "&items=10";
    if (LicenseSearchText === "") {
      url =
        "license/search/license?license_type=device&page=" + page + "&items=10";
    }
    axiosApiInstance
      .get(url)
      .then((res) => {
        flag = false;
        let arr = page === 1 ? [] : [...Licenselist];
        setTotalPages(res.data.total_count);
        for (let i = 0; i < res.data.details.length; i++) {
          arr.push(res.data.details[i]);
        }
        setTimeout(() => {
          setIsLoading(false);
          setLicenselist([...arr]);
        }, 1000);
      })
      .catch((err) => {})
      .finally(() => {
        // setIsLoading(false);
        page === 1 && scrollbar.current?.scrollTop(0);
      });
  };

  const getUnique = () => {
    axiosApiInstance
      .get("license/uniquecheck?licensename=" + LicenseName)
      .then((res) => {
        setUniqueCheck(res.data.details);
        if (res.data.details) {
          document
            .getElementById("_license_name")
            .classList.add("error_shake", "input__error");
        }
      })
      .catch((err) => {});
  };

  const getAttributes = () => {
    setIsLoading(true);
    axiosApiInstance
      .get("license/created/recent?license_type=device")
      .then((res) => {
        setLicense([...res.data.details.pricing_details]);
        currentAtrLength = res.data.details.pricing_details.length;
        for (let i = 0; i < res.data.details.pricing_details.length; i++) {
          attributeName.push(
            res.data.details.pricing_details[i].attribute_name
          );
        }
      })
      .catch((err) => {})
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleScroll = () => {
    if (scrollbar.current.getValues().top >= 0.95) {
      if (changePage <= Math.floor(TotalPages / 10) && !flag) {
        flag = true;
        changePage += 1;
        fetchLicense(changePage);
      }
    }
  };

  const handleUserScroll = () => {
    if (scrollbar.current.getValues().top >= 0.95) {
      if (changeUserPage <= Math.floor(TotalRestrictedUsers / 10) && !flag) {
        userFlag = true;
        changeUserPage += 1;
        getMfgNames(
          Licenselist[currentIndex].license_name,
          Type,
          changeUserPage
        );
      }
    }
  };

  const enableDisableLicense = (value, index) => {
    setIsLoading(true);
    axiosApiInstance
      .post("license/show/license", {
        license_id: Licenselist[index].license_id,
        show_to_user: value,
      })
      .then((res) => {
        if (value === true) {
          msg.errorText = "Successfully Enabled";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        } else {
          msg.errorText = "Successfully Disabled";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        }
      })
      .catch((err) => {
        msg.errorText = "Something went wrong";
        msg.header = "Error";
        msg.type = "alert";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .finally(() => {
        // fetchLicense(1);
        setIsLoading(false);
      });
  };

  const printError = (id) => {
    document.getElementById(id).classList.add("error_shake", "input__error");
  };

  const validateData = () => {
    let res = false;
    if (LicenseName === "" || UniqueCheck) {
      res = true;
      printError("_license_name");
    }
    for (let i = 0; i < License.length; i++) {
      if (License[i].attribute_name === "") {
        res = true;
        printError("input_" + i);
      }
    }
    return res;
  };

  const postData = () => {
    if (validateData()) {
      return;
    }
    console.log(License);
    // axiosApiInstance
    //   .post("license/add", {
    //     name: LicenseName.toLowerCase(),
    //     pricing_details: License,
    //     license_type: "device",
    //   })
    //   .then((res) => {
    //     setLicense([]);
    //     msg.errorText = "Successfully Added License";
    //     msg.header = "Success";
    //     msg.type = "success";
    //     setShowAlert(true);
    //     setTimeout(() => {
    //       setShowAlert(false);
    //     }, 3000);
    //   })
    //   .catch((err) => {
    //     msg.errorText = "Couldn't Add License";
    //     msg.header = "Error";
    //     msg.type = "alert";
    //     setShowAlert(true);
    //     setTimeout(() => {
    //       setShowAlert(false);
    //     }, 3000);
    //   })
    //   .finally(() => {
    //     setLicenseModal(false);
    //     fetchLicense(1);
    //     setLicenseName("");
      // });
  };

  const getMarkup = (name) => {
    axiosApiInstance
      .get("license/fetch/license?licensename=" + name)
      .then((res) => {
        let newArr = [...res.data.details.pricing_details];
        newArr.map((item, idx) => {
          arr.map((header, idx2) => {
            if (header !== "attribute_name") {
              if (newArr[idx][arr[idx2]].markup === 0) {
                newArr[idx][arr[idx2]].markup = "";
              }
            }
          });
        });
        setUpdatedMarkup([...newArr]);
      })
      .catch((err) => {});
  };

  function editAtris(val, idx, idx2, header) {
    let newArr = [...License];
    let _arr2 = [];
    if (
      header === "attribute_name" &&
      !attributeName.includes(newArr[idx][arr[idx2]])
    ) {
      newArr[idx][arr[idx2]] = val;
      setLicense([...newArr]);
    } else if (header !== "attribute_name") {
      newArr[idx][arr[idx2]].amount = val;
      setLicense([...newArr]);
    }
    for (let i = 0; i < newArr.length; i++) {
      if (attributeName[i] !== newArr[i].attribute_name) {
        _arr2.push(newArr[i].attribute_name);
      }
    }
    setAttributeNames([..._arr2]);
  }

  function addRow() {
    let newArr = [...License];
    let object = {
      attribute_name: "",
      monthly: {
        amount: 0,
      },
      yearly: {
        amount: 0,
      },
      quarterly: {
        amount: 0,
      },
      lifetime: {
        amount: 0,
      },
    };
    newArr.push(object);
    setLicense([...newArr]);
  }

  function editLicenseAtris(val, idx, idx2, header) {
    let newArr = [...EditLicense];
    // let arr2 = [];
    if (header !== "attribute_name") {
      newArr[idx][arr[idx2]].amount = val;
    }
    setEditLicense([...newArr]);
  }

  function deleteRow(idx) {
    let newArr = [...License];
    newArr.splice(idx, 1);
    setLicense([...newArr]);
  }

  function resetRow(idx) {
    let newArr = [...License];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] !== "attribute_name") {
        newArr[idx][arr[i]].amount = 0;
      }
    }
    setLicense([...newArr]);
  }

  function percentage(val, idx, idx2) {
    let newArr = [...UpdatedMarkup];
    let result = Number((val / 100) * currentAmount.toFixed(2));
    newArr[idx][arr[idx2]].markup = val;
    newArr[idx][arr[idx2]].amount = result + Number(currentAmount);
    newArr[idx][arr[idx2]].amount = newArr[idx][arr[idx2]].amount.toFixed(2);
    setUpdatedMarkup([...newArr]);
  }

  function reversePercentage(item) {
    let _data = { ...item };
    if (_data.markup === "") _data.markup = 0;
    let a = parseFloat(_data.markup) + 100;
    let b = _data.amount / a;
    let d = Math.round(b * 100);
    return d;
  }

  const getMfgNames = (name, type, page) => {
    setIsLoading(true);
    if (type === "assignMfg") {
      axiosApiInstance
        .get(
          "license/distribution?licensename=" +
            name +
            "&page=" +
            page +
            "&items=10"
        )
        .then((res) => {
          let arr = page === 1 ? [] : [...mfrDetails];
          setTotalRestrictedUsers(res.data.total_count);
          for (let i = 0; i < res.data.details.length; i++) {
            removeMfgData.push(res.data.details[i].username);
            arr.push(res.data.details[i]);
          }
          setTimeout(() => {
            setIsLoading(false);
            setmfrDetails([...arr]);
          }, 1000);
          // setmfrDetails([...res.data.details]);
        })
        .catch((err) => {})
        .finally(() => {
          // setIsLoading(false);
        });
    } else {
      axiosApiInstance
        .get(
          "license/get/restricted_users?license_name=" +
            name +
            "&page=" +
            page +
            "&items=10"
        )
        .then((res) => {
          // let newArr = [...mfrDetails];
          // usersUserName = [];
          userFlag = false;
          let arr = page === 1 ? [] : [...mfrDetails];
          setTotalRestrictedUsers(res.data.total_count);
          for (let i = 0; i < res.data.details.length; i++) {
            removeMfgData.push(res.data.details[i]);
            arr.push({
              username: res.data.details[i],
            });
            usersUserName.push(res.data.details[i]);
          }
          setTimeout(() => {
            setIsLoading(false);
            setmfrDetails([...arr]);
          }, 1000);
          // setmfrDetails([...newArr]);
        })
        .catch((err) => {});
    }
  };

  const getUsers = () => {
    if (!SearchText) {
      return;
    }
    let url = "user/superadmin/manufacturers?field=";
    if (Type === "restrictUser") {
      url = "user/search/restricted/users?searchname=";
    }
    setOperatorLoading(true);
    axiosApiInstance
      .get(url + SearchText)
      .then((data) => {
        setUserList(data.data.details);
      })
      .catch((err) => {})
      .finally(() => {
        setOperatorLoading(false);
      });
  };

  const postEditLicense = () => {
    axiosApiInstance
      .post("license/add/markup", {
        license_name: Licenselist[currentIndex].license_name,
        pricing_details: EditLicense,
      })
      .then((res) => {
        msg.errorText = "Successfully Edited License";
        msg.header = "Success";
        msg.type = "success";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .catch((err) => {
        msg.errorText = "Couldn't Edit License";
        msg.header = "Error";
        msg.type = "alert";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .finally(() => {
        setEditLicense([]);
        setEditLicenseModal(false);
        fetchLicense(1);
        setLicenselist([]);
        setLicense([]);
      });
  };

  const postMarkup = () => {
    let newArr = [...UpdatedMarkup];
    newArr.map((item, idx) => {
      arr.map((header, idx2) => {
        if (header !== "attribute_name") {
          if (newArr[idx][arr[idx2]].markup === "") {
            newArr[idx][arr[idx2]].markup = 0;
          }
        }
      });
    });
    axiosApiInstance
      .post("license/add/markup", {
        license_name: Licenselist[currentIndex].license_name,
        pricing_details: newArr,
      })
      .then((res) => {
        msg.errorText = "Successfully Added Markup";
        msg.header = "Success";
        msg.type = "success";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .catch((err) => {
        msg.errorText = "Couldn't Add Markup";
        msg.header = "Error";
        msg.type = "alert";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .finally(() => {
        setUpdatedMarkup([]);
        setMarkupModal(false);
        fetchLicense(1);
        setIsActive("");
      });
  };

  const removeMfg = (id) => {
    let newArr = [...mfrDetails];
    newArr.splice(id, 1);
    mgfUserName.splice(id, 1);
    usersUserName.splice(id, 1);
    setmfrDetails([...newArr]);
    if (
      removeMfgData.includes(mfrDetails[id].username) &&
      Type === "assignMfg"
    ) {
      axiosApiInstance
        .delete(
          "license/delete?license_id=" +
            Licenselist[currentIndex].license_id +
            "&username=" +
            mfrDetails[id].username
        )
        .then((res) => {})
        .catch((err) => {});
    }
  };

  const postMfg = () => {
    if (Type === "assignMfg") {
      axiosApiInstance
        .post("license/assignupdate", {
          name: Licenselist[currentIndex].license_name,
          pricing_details: Licenselist[currentIndex].pricing_details,
          child_manufacturer: mgfUserName,
          show_to_user: false,
        })
        .then((res) => {
          msg.errorText = "Successfully Assigned";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .catch((err) => {
          msg.errorText = "Couldn't Assign";
          msg.header = "Error";
          msg.type = "alert";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .finally(() => {
          setassignModal(false);
          setSearchText("");
          setUserList([]);
          setmfrDetails([]);
          mgfUserName = [];
          usersUserName = [];
          changeUserPage = 1;
        });
    } else {
      axiosApiInstance
        .post("license/edit/restricted_users", {
          license_id: Licenselist[currentIndex].license_id,
          restrictedlist: usersUserName,
        })
        .then((res) => {
          msg.errorText = "Successfully Restricted";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .catch((err) => {
          msg.errorText = "Couldn't Restrict";
          msg.header = "Error";
          msg.type = "alert";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .finally(() => {
          setassignModal(false);
          setmfrDetails([]);
          mgfUserName = [];
          usersUserName = [];
        });
    }
  };

  useEffect(() => {
    let dataa = encryptStorage.getItem("UID").roles;
    Role = dataa;
    // fetchLicense();
  }, []);

  const disableLicenseSave = () => {
    let res = false;
    if (LicenseName === "") {
      res = true;
    }
    for (let i = 0; i < License?.length; i++) {
      if (License[i].attribute_name === "") {
        res = true;
      }
    }
    if (License.length === 0) {
      res = true;
    }
    // if (errors["isPlanNameUnique"]) {
    //   res = true;
    // }

    if (!res) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="_license_wrapper_">
      <Navbar sidenav>
        <div className="license_body">
          <img src={bg} className="profile_bg" />
          <div className="body_content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1>License</h1>
            </div>
            <div className="license_data">
              <div className="add_plan_btn">
                <div className="search_container">
                  <InputBox
                    id="search"
                    placeholder="Search using License Name"
                    onChange={(e) => {
                      setLicenseSearchText(e.target.value);
                    }}
                    value={LicenseSearchText}
                    children={searchIcon()}
                    marginLeft
                  />
                </div>
                {Role.includes("superadmin") && (
                  <Button
                    onClick={() => {
                      setLicenseModal(true);
                      getAttributes();
                    }}
                    name="Create License"
                  />
                )}
              </div>

              {Licenselist.length === 0 ? (
                <div className="empty_license_screen">
                  {emptyLicenseIcon()}
                  <p className="empty_license_para">No License Found</p>
                  {/* {Role.includes("superadmin") && (
                    <p
                      onClick={() => {
                        setLicenseModal(true);
                        getAttributes();
                      }}
                      className="empty_license_subpara"
                    >
                      Create License
                    </p>
                  )} */}
                </div>
              ) : (
                <Scroller
                  autoHeightMax="57vh"
                  onScroll={handleScroll}
                  ref={scrollbar}
                >
                  <div className="license_list_container">
                    {Licenselist.map((item, index) => {
                      return (
                        <LicenseList
                          key={item.license_name + "idx"}
                          name={item.license_name}
                          pricingDetails={item.pricing_details}
                          editMarkup={() => {
                            setMarkupModal(true);
                            currentIndex = index;
                            getMarkup(item.license_name);
                          }}
                          Role={Role}
                          assignMfg={() => {
                            setType("assignMfg");
                            setassignModal(true);
                            currentIndex = index;
                            getMfgNames(item.license_name, "assignMfg", 1);
                          }}
                          editRestrcitUsers={() => {
                            setType("restrictUser");
                            setassignModal(true);
                            currentIndex = index;
                            getMfgNames(item.license_name, "restrictUser", 1);
                          }}
                          editLicense={() => {
                            setEditLicenseModal(true);
                            setEditLicense([...item.pricing_details]);
                            currentIndex = index;
                          }}
                          toggleValue={item.show_to_user}
                          toggleId={"license_toggle" + index}
                          handleToggleValue={(value) => {
                            enableDisableLicense(value, index);
                          }}
                          disableLicense={item.show_to_user}
                        />
                      );
                    })}
                  </div>
                </Scroller>
              )}

              {/* {Licenselist.length > 0 && TotalPages > 1 && (
                <div
                  className="device_bottom"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    background:
                      themeContext.Theme === "Light"
                        ? "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6783088235294117) 100%)"
                        : "linear-gradient(0deg, rgba(41,49,58,1) 0%, rgba(41,49,58,0.5183088235294117) 100%)",
                  }}
                >
                  <Pagination
                    totPages={TotalPages}
                    currentPage={CurrentPage}
                    rowCount={10}
                    pageClicked={(ele, count_) => {
                      var url = new URL(window.location.href);
                      url.searchParams.set("page", ele);
                      window.history.pushState(null, null, url);
                      setCurrentPage(ele);
                      fetchLicense(ele);
                    }}
                  />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </Navbar>
      <div className="license_modal">
        <AnimatedModal
          modalOpen={LicenseModal}
          className="create_license_modal"
        >
          <div className="license_modal_wrapper">
            <div
              className="close_otp_modal"
              onClick={() => {
                setLicenseModal(false);
                // setLicense([]);
                setLicenseName("");
                // clearStates();
              }}
            >
              {closeIcon()}
            </div>
            <div className="edit_license_table">
              <InputBox
                id="_license_name"
                value={LicenseName}
                placeholder="Enter License Name"
                onChange={(e) => {
                  setLicenseName(e.target.value);
                }}
                onFocus={() => {
                  handleFocus("_license_name");
                  // UniqueCheck(false)
                }}
                helperText={UniqueCheck ? "Name already exists" : ""}
              />
              <Scroller autoHeightMax="17vw" ref={createLicenseScroll}>
                <table>
                  <tr>
                    {arr.map((header, index) => {
                      return <th>{header.replace(/_/g, " ")}</th>;
                    })}
                  </tr>
                  {License.map((item, idx) => {
                    return (
                      <tr className="attribute_row">
                        {arr.map((header, idx2) => {
                          return header === "attribute_name" ? (
                            <td>
                              {/* {!attributeName.includes(item[header]) ? (
                                <div
                                  onClick={() => {
                                    deleteRow(idx);
                                  }}
                                  className="center"
                                >
                                  x
                                </div>
                              ) : (
                                <div
                                  onClick={() => {
                                    resetRow(idx);
                                  }}
                                  className="center"
                                >
                                  -
                                </div>
                              )} */}
                              <div
                                onClick={() => {
                                  deleteRow(idx);
                                }}
                                className="center"
                              >
                                x
                              </div>
                              <input
                                // autoFocus
                                id={"input_" + idx}
                                value={item[header]}
                                onChange={(e) => {
                                  editAtris(e.target.value, idx, idx2, header);
                                }}
                                onFocus={() => handleFocus("input_" + idx)}
                              />
                            </td>
                          ) : (
                            <td
                              key={item[header] + "idx2" + idx2 + "secondcol"}
                            >
                              <input
                                value={item[header]?.amount}
                                onChange={(e) => {
                                  if (Number(e.target.value) <= 9999999) {
                                    editAtris(
                                      Number(
                                        e.target.value.replace(/[^0-9]/g, "")
                                      ),
                                      idx,
                                      idx2
                                    );
                                  }
                                }}
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </table>
              </Scroller>
              <Button
                id="add_row"
                onClick={() => {
                  addRow();
                }}
                name="+ Attribute"
              />
              <Button
                id="save_btn"
                onClick={() => {
                  postData();
                  // postAttributes();
                }}
                style={{
                  position: "absolute",
                  right: "3%",
                  bottom: "2%",
                }}
                name="Save"
                disabled={disableLicenseSave()}
              />
            </div>
          </div>
        </AnimatedModal>
      </div>
      <div className="_edit_license_modal">
        <AnimatedModal
          modalOpen={EditLicenseModal}
          className="edit_license_modal"
        >
          <div className="edit_license_modal_wrapper">
            <div
              className="close_otp_modal"
              onClick={() => {
                setEditLicenseModal(false);
                // clearStates();
              }}
            >
              {closeIcon()}
            </div>
            <div className="edit_license_table">
              <InputBox
                id="_license_name___"
                value={Licenselist[currentIndex]?.license_name}
                disabled
              />

              <Scroller autoHeightMax="21vw" ref={userScroll}>
                <table>
                  <tr>
                    {arr.map((header, index) => {
                      return (
                        <th key={header + index + "index" + "header"}>
                          {header.replace(/_/g, " ")}
                        </th>
                      );
                    })}
                  </tr>
                  {EditLicense.map((item, idx) => {
                    return (
                      <tr key={"idx" + idx + "row"} className="attribute_row">
                        {arr.map((header, idx2) => {
                          return header === "attribute_name" ? (
                            <td key={item[header] + "idx2" + idx2 + "column"}>
                              <input
                                // autoFocus
                                id={"input_" + idx}
                                value={item[header]}
                              />
                            </td>
                          ) : (
                            <td
                              key={item[header] + "idx2" + idx2 + "secondcol"}
                            >
                              <input
                                value={item[header]?.amount}
                                onChange={(e) => {
                                  if (Number(e.target.value) <= 9999999) {
                                    editLicenseAtris(
                                      Number(
                                        e.target.value.replace(/[^0-9]/g, "")
                                      ),
                                      idx,
                                      idx2
                                    );
                                  }
                                }}
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </table>
              </Scroller>
              <Button
                id="save_btn"
                onClick={() => {
                  postEditLicense();
                }}
                style={{
                  position: "absolute",
                  right: "3%",
                  bottom: "2%",
                }}
                name="Save"
              />
            </div>
          </div>
        </AnimatedModal>
      </div>
      <div className="markup_modal">
        <AnimatedModal modalOpen={MarkupModal} className="edit_markup_modal">
          <div className="markup_modal_wrapper">
            <div
              className="close_otp_modal"
              onClick={() => {
                setMarkupModal(false);
                setIsActive("");
              }}
            >
              {closeIcon()}
            </div>
            <div className="edit_markup_table">
              <InputBox
                id="__license_name___"
                value={Licenselist[currentIndex]?.license_name}
                disabled
              />
              <Scroller autoHeightMax="21vw" ref={userScroll}>
                <table>
                  <tr>
                    {arr2.map((header, idx) => {
                      return (
                        <th
                          key={header + idx + "markup"}
                          style={{ textTransform: "capitalize" }}
                        >
                          {header.replace(/_/g, " ")}
                        </th>
                      );
                    })}
                  </tr>
                  {UpdatedMarkup.map((item, idx) => {
                    return (
                      <tr
                        key={idx + "markup" + "row"}
                        className="attribute_row"
                        style={{
                          height:
                            item.attribute_name === isActive ? "10vh" : "5vh",
                        }}
                      >
                        {arr2.map((header, idx2) => {
                          return header === "attribute_name" ? (
                            <td key={item[header] + idx2 + "markup" + "column"}>
                              {item[header]}
                            </td>
                          ) : header === "" ? (
                            <td key={idx2 + "markup" + "column"}>
                              {item.attribute_name !== isActive ? (
                                <Button
                                  onClick={() => {
                                    setIsActive(item.attribute_name);
                                  }}
                                  name="Add"
                                  style={{
                                    padding: "0.8vw",
                                    backgroundColor: "#0433980D",
                                    color: "var(--primary)",
                                    borderRadius: "0px 4px 4px 0px",
                                  }}
                                />
                              ) : (
                                <Button
                                  onClick={() => {
                                    setIsActive("");
                                  }}
                                  style={{
                                    height: "10vh",
                                    backgroundColor: "#0433980D",
                                    color: "var(--primary)",
                                    borderRadius: "0px 4px 4px 0px",
                                  }}
                                  name="Done"
                                />
                              )}
                            </td>
                          ) : (
                            <td>
                              <p
                                style={{
                                  height:
                                    item.attribute_name === isActive && "2vw",
                                }}
                              >
                                {item[header]?.amount}
                              </p>{" "}
                              {item.attribute_name === isActive && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {" "}
                                  <input
                                    className="markup_input_"
                                    value={item[header].markup}
                                    maxlength={5}
                                    onFocus={() => {
                                      setcurrentAmount(
                                        reversePercentage(item[header])
                                      );
                                    }}
                                    onChange={(e) => {
                                      if (Number(e.target.value) <= 100)
                                        if (
                                          e.target.value.indexOf(".") === -1 ||
                                          (e.target.value.includes(".") &&
                                            e.target.value.length -
                                              e.target.value.indexOf(".") <=
                                              3)
                                        ) {
                                          percentage(
                                            e.target.value.replace(
                                              /[^\d.]+/g,
                                              ""
                                            ),
                                            idx,
                                            idx2
                                          );
                                        }
                                    }}
                                  />
                                  <p className="percentage_para_">%</p>
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </table>
              </Scroller>
              <Button
                id="save_btn"
                onClick={() => {
                  postMarkup();
                }}
                style={{
                  position: "absolute",
                  right: "2%",
                  bottom: "2%",
                }}
                name="Save"
              />
            </div>
          </div>
        </AnimatedModal>
      </div>
      <div className="assign_modal">
        <AnimatedModal
          modalOpen={assignModal}
          className="upgrade_licence_modal"
        >
          <div className="assign_mfr_wrapper">
            <div
              className="close_otp_modal"
              onClick={() => {
                setassignModal(false);
                setSearchText("");
                setUserList([]);
                changeUserPage = 1;
              }}
            >
              {closeIcon()}
            </div>
            <p className="assign_label">
              {Type === "assignMfg"
                ? "Assign to Manufacturers"
                : "Add Users To Restrict"}
            </p>

            <Searchbar
              placeholder="Search by username"
              handleSearch={(e) => {
                setSearchText(e.target.value);
                if (e.target.value === "") {
                  setUserList([]);
                }
              }}
              autoFocus
              onFocus={() => {
                setDisappearSearch(true);
              }}
              value={SearchText}
              className="search_bar_mfr"
            />
            {OperatorLoading && <LoadingText />}
            {UserList.length > 0 && DisappearSearch && (
              <ul className="autocomplete_results">
                <Scroller autoHeightMax="15vw">
                  <span className="_span" />
                  {UserList?.map((item, index) => (
                    <li
                      key={item.username + index + "index"}
                      className="options"
                      onClick={() => {
                        setSearchText("");
                        setUserList([]);

                        let _mfrDetails = [...mfrDetails];
                        let repeated = false;

                        _mfrDetails.map((items, index) => {
                          if (items.username === item.username) {
                            repeated = true;
                            document.getElementById("license_" + index).focus();
                          }
                        });

                        if (!repeated) {
                          mgfUserName.push(item.username);
                          setmfrDetails([..._mfrDetails, item]);
                          usersUserName.push(item.username);
                        }
                      }}
                      style={{ textTransform: "capitalize" }}
                    >
                      {item.username}
                    </li>
                  ))}
                </Scroller>
              </ul>
            )}

            <div className="mfr_table">
              <Scroller
                onScroll={handleUserScroll}
                ref={scrollbar}
                autoHeightMax={"18vw"}
                autoHeightMin={"18vw"}
              >
                {mfrDetails.length > 0 ? (
                  <table id="mfr">
                    <tr style={{ height: "4vh" }}>
                      <th>Sr.No</th>
                      <th style={{ textAlign: "left" }}>Manufacturer</th>
                      <th></th>
                    </tr>

                    {mfrDetails?.map((item, index) => (
                      <tr key={index + "mfrMap"} className="td_child_row">
                        <td>{index + 1}</td>
                        <td style={{ textAlign: "left" }}> {item.username}</td>
                        <td
                          style={{
                            cursor: "pointer",
                            textAlign: "right",
                            fontSize: "0.7vw",
                          }}
                          onClick={() => {
                            removeMfg(index);
                          }}
                        >
                          {trashIcon()} remove
                        </td>
                      </tr>
                    ))}
                  </table>
                ) : (
                  <p className="no_data_found">No Data Found</p>
                )}
              </Scroller>
            </div>

            <div className="mfr_btns">
              <Button
                name="Save"
                style={{ width: "9vw", padding: "0.4vw" }}
                onClick={postMfg}
              />
            </div>
          </div>
        </AnimatedModal>
      </div>

      {IsLoading && <Loading type={"transparent"} text={"Loading"} />}
      <AnimatedModal
        modalOpen={ShowAlert}
        handleClose={() => {
          setShowAlert(false);
        }}
        type={msg.type}
        errorHeader={msg.header}
        errorText={msg.errorText}
        // timeout={5000}
        alwayOpen={true}
      />
    </div>
  );
}

const trashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      style={{ height: "0.6vw", width: "0.6vw" }}
      fill="#00000080"
    >
      <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
    </svg>
  );
};

const emptyLicenseIcon = () => {
  return (
    <svg
      width={143}
      height={143}
      viewBox="0 0 143 143"
      style={{ width: "10vw", height: "10vw" }}
      fill="none"
      className="emptyLicenseIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_48_388)">
        <path
          d="M142.745 70.472C142.745 70.4682 142.748 70.465 142.752 70.465V70.465C142.756 70.465 142.759 70.4618 142.759 70.4579C142.757 65.5138 140.821 61.0219 137.673 57.6706C137.672 57.6689 137.672 57.6663 137.673 57.6647V57.6647C137.675 57.6632 137.675 57.6608 137.674 57.6591L111.181 23.6305C110.619 22.9079 109.754 22.4854 108.838 22.4854H32.9926C32.052 22.4854 31.1671 22.931 30.6071 23.6867L4.90465 58.3692C4.90198 58.3728 4.90235 58.3778 4.90552 58.381V58.381C4.90885 58.3843 4.90907 58.3897 4.90603 58.3933C2.51884 61.22 1.00478 64.7728 0.630719 68.6576C0.591609 69.0638 0.463432 69.4549 0.345416 69.8455C0.278361 70.0675 0.238403 70.3003 0.238403 70.5465V117.234C0.238403 118.787 1.49665 120.043 3.04683 120.043H139.953C141.506 120.043 142.762 118.788 142.762 117.234V70.5465C142.762 70.5209 142.748 70.4973 142.745 70.472ZM33.1597 29.4182C33.711 28.5957 34.636 28.1022 35.6261 28.1022H106.294C107.259 28.1022 108.163 28.5706 108.719 29.3583L124.246 51.3382C124.371 51.5149 124.241 51.7398 124.025 51.7398V51.7398H93.3085C91.6687 51.7398 90.3393 53.0692 90.3393 54.709V60.1589C90.3393 69.7184 80.3023 67.6514 77.2248 67.6514H66.0083C62.9304 67.6514 52.8938 69.7184 52.8938 60.1589V54.709C52.8938 53.0692 51.5644 51.7398 49.9246 51.7398H19.2054V51.7398C18.7739 51.7398 18.5041 51.282 18.7444 50.9236L33.1597 29.4182ZM137.145 111.457C137.145 113.097 135.816 114.426 134.176 114.426H8.8269C7.18704 114.426 5.85768 113.097 5.85768 111.457V70.5465V70.5465C5.85768 70.5018 5.87952 70.465 5.92427 70.465H5.97172C6.03734 70.465 6.09048 70.4112 6.09107 70.3456C6.15542 63.1718 12.0136 57.356 19.2051 57.356H44.474C46.0218 57.356 47.2766 58.6107 47.2766 60.1585V60.1585C47.2766 69.8276 54.6288 73.2675 66.008 73.2675H77.2244C88.6064 73.2675 95.9558 69.8276 95.9558 60.1585V60.1585C95.9558 58.6107 97.2106 57.356 98.7584 57.356H124.03C127.644 57.356 130.922 58.8246 133.297 61.1977L133.303 61.2033C135.674 63.5742 137.139 66.8449 137.142 70.4551C137.142 70.4605 137.146 70.465 137.152 70.465V70.465C137.157 70.465 137.162 70.4694 137.161 70.4748C137.158 70.499 137.145 70.5215 137.145 70.5465L137.145 111.457Z"
          fill="#367BC0"
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_48_388">
          <rect
            width={142.523}
            height={142.523}
            fill="white"
            transform="translate(0.238281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
